/**
 * Return corrently pluralized form given a count and singlar/plural forms of the word.
 * 
 * e.g. 
 *  pluralize(1, 'potato', 'potatoes') //=> "1 Potato"
 *  pluralize(7, 'potato', 'potatoes') //=> "7 Potatoes"
 * 
 * @param {number} count The number of items
 * @param {string} singular Singluar form of the word
 * @param {string} plural Plural form of the word
 */
export default function pluralize(count, singular, plural = null) {
  if (!plural && singular.one && singular.other) {
    return pluralize(count, singular.one, singular.other);
  }

  if (count === 1) {
    return `1 ${singular}`;
  } else {
    return `${count} ${plural}`;
  }
}
